import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

import Logo from "../assets/images/logo-footer.png";

import "../assets/style/footer.css";

const Footer = () => (
	<footer>
		<div id="flex">
			<div>
				<img src={Logo} alt="nofapguidance" />
			</div>
			<div id="footer-links">
				<ul>
					<li><Link to="/reviews">Reviews</Link></li>
					<li><Link to="/pricing">Pricing</Link></li>
					<li><Link to="/blog">Blog</Link></li>
				</ul>
				<ul>
					<li><a href="https://instagram.com/nofapguidance">Instagram</a></li>
					<li><a href="mailto:nofapguidance@gmail.com">Email Us</a></li>
					<li><Link to="/donate-a-program">Donate</Link></li>
				</ul>
			</div>
		</div>	
		<p><FontAwesomeIcon icon={faCopyright} /> nofapguidance {new Date().getFullYear()}. All rights reserved. +852 6150 7145</p>
		<p>Made by Salint. <a href="mailto:mohamed@salint.me">mohamed@salint.me</a></p>
	</footer>
);

export default Footer;